import FileUpload from "../../../../../../Components/FileUploadForm";

export default function AddDocument({
  title,
  savId,
  isInternal = false,
  refetch = () => Promise.resolve()
}: {
  title?: string;
  savId: number;
  isInternal?: boolean;
  refetch?: () => Promise<any>;
}) {


  return (
    <div className="row">

      <div className="col-12 my-2">
        <div className="bg-light border rounded shadow h-100 mx-0 px-4 py-3">
          <div className="row py-2 border-bottom mb-2">
            <span className="text-uppercase fw-bold fs-5">{title || "Ajouter un nouveau document"}</span>
          </div>

          <div className="row flex-row">
            <FileUpload
              uploadPath={"/sav/" + savId + "/documents/upload"}
              onUploadSuccess={() => {
                refetch();
              }}
              customData={{
                isInternal
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}